// The onboarding GenUI document addresses its state under `/screen`, so the flow
// store keys every answer as a JSON Pointer (`/screen/program_key`). Persistence —
// and the voice minter that reads these answers — speaks neutral, flat keys
// (`program_key`). These map the two worlds at the host-tool boundary (per the
// save_flow_session contract) so the repository stays GenUI-agnostic: the store
// keeps the pointers its bindings need, the wire carries flat keys.
// One definition, in the package a server-side reader can also reach: the
// persisted key shapes this maps between are exactly what `readAnswer` and the
// answer normaliser have to tolerate on the way back out.
import { FLOW_STATE_ROOT_PREFIX } from '@galapagos/shared';

export function relativizeFlowAnswers(values: Record<string, unknown>): Record<string, unknown> {
  const out: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(values)) {
    out[key.startsWith(FLOW_STATE_ROOT_PREFIX) ? key.slice(FLOW_STATE_ROOT_PREFIX.length) : key] =
      value;
  }
  return out;
}

export function absolutizeFlowAnswers(values: Record<string, unknown>): Record<string, unknown> {
  const out: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(values)) {
    out[key.startsWith('/') ? key : `${FLOW_STATE_ROOT_PREFIX}${key}`] = value;
  }
  return out;
}
